<template>
  <div
    class="view-details position-cen"
    :class="{ 'view-details': true, show: showDetail }"
  >
    <div class="flex flex-v-center flex-h-end">
      <img
        src="/img/circle-x.svg"
        alt="close"
        class="pointer"
        @click.prevent="$emit('toggleView')"
      />
    </div>
    <div class="view-body mt-20">
      <div class="view-body-item mb-20">
        <p class="label">Status:</p>
        <p
          class="status pending"
          v-if="reportDetail.exemption_status === 'pending'"
        >
          {{ reportDetail.exemption_status && reportDetail.exemption_status }}
        </p>
        <p
          class="status approve"
          v-if="reportDetail.exemption_status === 'approved'"
        >
          {{ reportDetail.exemption_status && reportDetail.exemption_status }}
        </p>
        <p
          class="status reject"
          v-if="reportDetail.exemption_status === 'rejected'"
        >
          {{ reportDetail.exemption_status && reportDetail.exemption_status }}
        </p>
      </div>
      <div class="view-body-item">
        <p class="label">Reason:</p>
        <p>
          {{ reportDetail.exemption_reason && reportDetail.exemption_reason }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["showDetail", "reportDetail"],
};
</script>

<style scoped>
.view-body {
  display: flex;
  flex-direction: column;
  min-width: 200px;
}
.view-body-item {
  text-transform: capitalize;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.position-cen {
  position: absolute;
  top: 50%;
  right: 5%;
}
</style>
